<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { Calendar } from 'lucide-vue-next'
import DashboardEventCard from './DashboardEventCard.vue'
import EmptyState from '@lib/components/shared/EmptyState.vue'
import type { DashboardEvent } from './dashboard-process'

defineProps<{
    events: DashboardEvent[]
}>()

const { t } = useI18n()
</script>

<template>
    <section class="mb-6">
        <div class="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
            <div class="flex items-center gap-3 px-4 py-3 border-b border-gray-200 flex-wrap">
                <div class="w-6 h-6 rounded-lg bg-teal/10 flex items-center justify-center">
                    <Calendar class="w-3.5 h-3.5 text-teal" />
                </div>
                <span class="text-sm font-semibold text-ink">{{ t('dashboard.events.title') }}</span>
                <span class="text-xs text-gray-500 ml-1">{{ events.length }}</span>
                <RouterLink to="/events" class="ml-auto text-xs text-teal hover:underline">
                    {{ t('dashboard.events.showAll') }}
                </RouterLink>
            </div>
            <div v-if="events.length === 0" class="p-6">
                <EmptyState :title="t('dashboard.events.empty')" />
            </div>
            <div v-else class="divide-y divide-gray-100">
                <DashboardEventCard v-for="e in events" :key="e.id" :event="e" />
            </div>
        </div>
    </section>
</template>
